import { EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class BankOfficeApiService extends EntityApiService {

}

export default new BankOfficeApiService(`${authentication.path}/api/bank-offices`);
